import { ICompileService } from "angular";
import { RecordDataSource } from "../../../../records/grids";
import {
  lookupValueGetterFactory,
  moneyValueGetterFactory,
  percentageValueGetterFactory,
} from "../../../../records/grids/cells/valueGetters";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { FilterProvider } from "../../../../records/grids/columns/filters/FilterProvider";
import { LookupFilter } from "../../../../records/grids/columns/filters/subFilters/LookupFilter";
import { OptionsFilter } from "../../../../records/grids/columns/filters/subFilters/OptionsFilter";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";

const gridId = Symbol("main.projects.grid");
export class ProjectsViewController {
  static $inject = [
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
  ];

  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {
    Status: "Floor",
  };

  constructor(
    serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService
  ) {
    this.gridDataSource = new RecordDataSource(serverUtility, "api/machines/Project");
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    this.columns = [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        hide: true,
      }),

      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Project Name",
        filter: new FilterProvider("Name", $compile)
          .defaultStringFilters()
          .getGridFilterFactory()
      }),

      columnDefinitionService.getStringColDef({
        field: "ProjectChangesChangeType",
        header: "Change Type",
        filter: new FilterProvider("ProjectChangesChangeType", $compile)
          .defaultStringFilters()
          .getGridFilterFactory()
      }),

      columnDefinitionService.getStringColDef({
        field: "ProjectChangesStatus",
        header: "Change Status",
        filter: new FilterProvider("ProjectChangesStatus", $compile)
          .defaultStringFilters()
          .getGridFilterFactory()
      }),

      columnDefinitionService.getStringColDef({
        field: "CreatedByDisplayName",
        header: "Created By"

      }),

      columnDefinitionService.getDateColDef({
        field: "CreatedDate",
        header: "Created Date"
      }),
    ];
  }

}
